import { render, staticRenderFns } from "./EmailLeftSidebar.vue?vue&type=template&id=818fc81c"
import script from "./EmailLeftSidebar.vue?vue&type=script&lang=js"
export * from "./EmailLeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./EmailLeftSidebar.vue?vue&type=style&index=0&id=818fc81c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports